import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

import pxToRem from "@/themes/functions/pxToRem";

interface ISvgIcon {
  defaultProps: ComponentsProps["MuiSvgIcon"];
  styleOverrides: ComponentsOverrides<Theme>["MuiSvgIcon"];
}

const svgIcon: ISvgIcon = {
  defaultProps: {
    fontSize: "inherit",
  },

  styleOverrides: {
    fontSizeInherit: {
      fontSize: "inherit !important",
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`,
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`,
    } as CSSObject,
  },
};

export default svgIcon;
